module.exports = __webpack_public_path__ + "static/media/07.fdd9f3ac.png";